export default __webpack_public_path__ + "static/media/picasa.f07c47c1.svg";